/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaFlowNodeTypeOutputDefinitionMap,
	TGetBlueprintSchemaSpec
} from "@adapptio/lib-blueprint";
import { NODE_OUTPUTS, NODE_OUTPUT_NAMES, NODE_TYPES } from "./BlueprintNode";
import { termsEditor } from "../../terms";

export const BlueprintConditionNode = {
	name: NODE_TYPES.CONDITION,
	label: "Condition",
	icon: "mdi/help-rhombus",
	editorOptions: {
		displayInPalette: true
	},
	opts: BP.Object({
		label: termsEditor.nodes.common.options.label,
		description: termsEditor.nodes.common.options.description,
		props: {
			condition: BP.Prop(
				BP.Boolean({
					label: termsEditor.nodes.condition.condition.label,
					description: termsEditor.nodes.condition.condition.description
				})
			)
		},
		editorOptions: {
			layoutType: "passthrough"
		}
	}),
	resolveOutputs: (): ISchemaFlowNodeTypeOutputDefinitionMap => ({
		[NODE_OUTPUT_NAMES.ON_TRUE]: NODE_OUTPUTS.ON_TRUE,
		[NODE_OUTPUT_NAMES.ON_FALSE]: NODE_OUTPUTS.ON_FALSE
	})
};

export type TBlueprintConditionNodeOptsSchemaSpec = TGetBlueprintSchemaSpec<
	typeof BlueprintConditionNode["opts"]
>;
